import React, { useState } from "react";

import "./styles.less";
import { Table, Column } from "../../components/NormalTable";
import { useTranslation } from "react-i18next";

export const SolutionSceneTable = (props) => {
  const { t } = useTranslation();
  const { data } = props;

  const renderChecked = (value) => {
    const iconStyl = {
      color: "#35CE86",
      textAlign: "center",
      margin: "0 auto",
      display: "block",
      // color: "rgba(57, 106, 255, 0.8)",
    };
    const uniconStyl = {
      color: "#545968",
      textAlign: "center",
      margin: "0 auto",
      display: "block",
      fontSize: "19px",
    };
    const checkedIcon = (
      <div>
        <i className="icon authing-icon authing-wancheng" style={iconStyl}></i>
      </div>
    );
    const uncheckedIcon = (
      <div>
        <i
          className="icon authing-icon authing-close-circle-fill1"
          style={uniconStyl}
        ></i>
      </div>
    );
    if (value === "checked") {
      return checkedIcon;
    } else if (value === "unchecked") {
      return uncheckedIcon;
    } else {
      return value;
    }
  };
  return (
    <>
      <div className="solution-scene-table">
        <Table data={data}>
          {data.map((column) => {
            if (column.nametype) {
              return (
                <Column
                  title={column.nametype}
                  dataIndex={column.dataIndex}
                  render={renderChecked}
                  extra={column.extra}
                />
              );
            } else {
              return <></>;
            }
          })}
        </Table>
      </div>
    </>
  );
};
